import React from 'react';
import { useStore } from 'effector-react';
import { AutoRotateEndOperation, SceneType } from '@types';
import { Dropdown, type DropdownItem } from '@components/Dropdown';
import { Collapse } from '@components/Collapse';
import { $sceneMapApi } from '@stores/dataStores';
import { $loadedScene } from '@stores/loadedStore';
import SidebarApplyTo from '@modules/sidebar/components/SidebarApplyTo';
import { sendSuccess } from '@components/Noti';
import { showSceneModal } from '@modules/category';
import { switchTypeItems } from '@modules/panel/constants';
import SceneSelector from '../../panel/components/SceneSelector';

const items: DropdownItem<AutoRotateEndOperation>[] = [
  { id: AutoRotateEndOperation.byTour, name: '导览结束跳转场景' },
  { id: AutoRotateEndOperation.byVoice, name: '讲解结束跳转场景' },
  { id: AutoRotateEndOperation.loop, name: '当前场景循环导览讲解' },
  { id: AutoRotateEndOperation.stop, name: '导览讲解结束后停止' },
];

const itemsPV: DropdownItem<AutoRotateEndOperation>[] = [
  { id: AutoRotateEndOperation.byTour, name: '播放结束跳转场景' },
  { id: AutoRotateEndOperation.byVoice, name: '讲解结束跳转场景' },
  { id: AutoRotateEndOperation.loop, name: '当前场景循环播放讲解' },
  { id: AutoRotateEndOperation.stop, name: '播放讲解结束后停止' },
];

export function EndOperationSetting() {
  const scene = useStore($loadedScene)!;
  const {
    targetSceneId = '',
    endOperation = AutoRotateEndOperation.byTour,
    animation = 0,
  } = scene.config.autoRotate ?? {};

  const showSwitchSetting =
    endOperation === AutoRotateEndOperation.byTour ||
    endOperation === AutoRotateEndOperation.byVoice;

  const handleApplyTo = async () => {
    const { idSet } = await showSceneModal({
      title: '选择要应用到的场景',
      subTitle: '注：只能应用到同类型场景中',
      allowedTypes: [scene.type],
      multiple: true,
    });
    if (!idSet) return;
    $sceneMapApi.update((draft) => {
      Array.from(idSet).forEach((_id) => {
        draft.get(_id)!.config.autoRotate!.endOperation = endOperation;
        draft.get(_id)!.config.autoRotate!.targetSceneId =
          _id === targetSceneId ? undefined : targetSceneId;
        draft.get(_id)!.config.autoRotate!.animation = animation;
      });
    });
    sendSuccess('导览交互已应用到所选场景');
  };

  return (
    <Collapse title="导览交互">
      <Dropdown
        selected={endOperation}
        items={scene.type === SceneType.panoVideo ? itemsPV : items}
        onChange={(typeId) => {
          $sceneMapApi.updateScene({
            id: scene.id,
            updater: (draft) => {
              draft.config.autoRotate!.endOperation = typeId;
            },
          });
        }}
      />
      {showSwitchSetting && (
        <>
          <SceneSelector
            className="mt-20"
            withDeleteBtn
            disabledIds={[scene.id]}
            sceneId={targetSceneId}
            onChange={(sceneId) => {
              $sceneMapApi.updateScene({
                id: scene.id,
                updater: (draft) => {
                  draft.config.autoRotate!.targetSceneId = sceneId ?? '';
                },
              });
            }}
          />
          <div className="mt-20 mb-10">切换动画设置</div>
          <Dropdown
            items={switchTypeItems}
            selected={animation}
            onChange={(typeId) => {
              $sceneMapApi.updateScene({
                id: scene.id,
                updater: (draft) => {
                  draft.config.autoRotate!.animation = typeId;
                },
              });
            }}
          />
          <div className="mt-10 text-sm text-orange">
            注：未设置目标场景则自动跳转下一场景
          </div>
        </>
      )}
      <SidebarApplyTo
        title="把导览交互应用到..."
        className="mt-20"
        onClick={handleApplyTo}
      />
    </Collapse>
  );
}
